<div class="bg-primary-500 h-screen flex items-center justify-center">
  <div class="text-center text-8xl text-white">
    Oooooppss page not found 🤷‍♂️
  </div>
</div>
